import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { addBazsho, getAllBazsho, getHalat } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { toggleNWinDoor } from "Constants/Constants";
import { checkStype } from "Helpers/checkLabel";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import MuiButton from "Components/MuiButton/MuiButton";
import {DialogActions} from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import * as Icons from 'react-bootstrap-icons';

function NewBazshoDialog({ selectedBrandYaragh, reGetOnBack }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { halatList } = useSelector((state) => ({
    halatList: state.yaragh.halatList,
  }));
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    winDoor: {
      type: "toggle",
      arrayItems: toggleNWinDoor,
      value: toggleNWinDoor[0],
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12
      },
    },
    bazshoName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12
      },
    },
    halatBazsho: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));

  };
  const tanzimatProfileHandler = () => setOpenDialog(true);

  const autoCompleteHandler = (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  }

  const onChangeToggle = async(name, key, value) => {
    setControls({ [name]: { value: value } });
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Stype: checkStype(selectedBrandYaragh.IdStruct, value.value),
      };
      await dispatch(getHalat(params));
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const onFinish = async (e) => {
    e.preventDefault();
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      const { bazshoName, halatBazsho } = controls;
      try {
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          StypePop: halatBazsho.value.Id,
          Name: bazshoName.value,
          IdBrandFitting: selectedBrandYaragh.Id,
        };
        await dispatch(addBazsho(data));
        handleDialog();
        await reGetOnBack(true);
      } catch (e) {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
      }
      handleDialog();
    } else {
      setCheckValid(true);
    }
  };

  const onEnter = async () => {
    setFormValid({});
    setCheckValid(false);
    setControls({ winDoor: { value: toggleNWinDoor[0] } });
    setControls({ halatBazsho: { value: "" } });
    setControls({ bazshoName: { value: "" } });
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Stype: checkStype(selectedBrandYaragh.IdStruct, controls.winDoor.value.value),
      };
      await dispatch(getHalat(params));
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  useEffect(() => {
    if (halatList) {
      setControls({ halatBazsho: { selectItems: halatList } });
      setControls({ halatBazsho: { value: halatList[0] } });
    }
  }, [halatList]);

  return (
    <>
      <MuiIconButton
        title={<Translator id={"addNewPop"}/>}
        icon={<Icons.FileEarmarkPlus size={17}/>}
        onClick={tanzimatProfileHandler}
        className="fix-size"
        disabled={
          selectedBrandYaragh.Disable ||
          (selectedBrandYaragh.IsG && read("StypeU") !== "1")
        }
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>{<Translator id={"addNewPop"}/>}</p>
          </div>
          <DialogContent>
            {!loading ? (
              <Grid container spacing={3}>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid item sm={controls[key].col.sm} xs={controls[key].col.xs} key={key + index}>
                      {
                        controls[key].type === "select" &&
                        <MuiAutoComplete
                          autoSelect={true}
                          loading={loading}
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                        />
                      }
                      {
                        controls[key].type === "toggle" &&
                        <MuiRadioGroup
                          name={key}
                          // label={<Translator id={key} />}
                          value={controls[key].value}
                          items={controls[key].arrayItems}
                          onChange={onChangeToggle}
                          translate={true}
                          className="horizontalRadio"
                        />
                      }
                      {
                        controls[key].type === "text" &&
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          validation={controls[key].validation}
                          label={<Translator id={key} />}
                          type="text"
                          checkValid={checkValid}
                          value={controls[key].value}
                        />
                      }
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <MuiSkeleton xs={4} number={6} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default NewBazshoDialog;
